// extracted by mini-css-extract-plugin
export var cardImage = "FeatureCard-module--card-image--6fbbc";
export var cardSubtitle = "FeatureCard-module--card-subtitle--276fe";
export var cardText = "FeatureCard-module--card-text--bcba7";
export var halfSizeCard = "FeatureCard-module--halfSizeCard--5c11b";
export var smallCardImage = "FeatureCard-module--smallCardImage--46556";
export var smallCardSubtitle = "FeatureCard-module--smallCardSubtitle--90116";
export var smallCardText = "FeatureCard-module--smallCardText--038d4";
export var smallDate = "FeatureCard-module--smallDate--be366";
export var tabletOnly = "FeatureCard-module--tablet-only--b1d2b";